import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import { compose } from "recompose";
import ReactSpeedometer from "react-d3-speedometer";

const EngagementRateGraph = ({ classes, data }) => {
  // 1. Parse the incoming data safely.
  const numericValue = data ? parseFloat(data) : 0;

  return (
    <div className={classes.gaugeGraphConatiner}>
      <ReactSpeedometer
        needleHeightRatio={0.7}
        maxValue={100}
        segments={200}
        height={200}
        // Use a gradient-like effect or solid colors
        startColor="red"
        endColor="green"
        needleColor="black"
        // 2. Pass the parsed value here so the needle moves
        value={numericValue}
        // 3. Display the text dynamically
        currentValueText={`${numericValue.toFixed(2)}%`}
        valueTextFontSize={"20px"}
        ringWidth={document.documentElement.clientWidth > 1000 ? 40 : 20}
        maxSegmentLabels={0}
      />
    </div>
  );
};

const styles = (theme) => ({
  gaugeGraphConatiner: {
    width: "100%",
    display: "flex",
    height: 300,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  // Note: 'gaugChart' class wasn't applied in your JSX,
  // but if you need to override internal SVG styles, you'd apply it to a wrapper.
});

export default compose(
  withStyles(styles, { withTheme: true }),
  withRouter
)(EngagementRateGraph);
